import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import CrudView from 'components/Crud/CrudView';
import RoleMessages from './messages';
import productRoleMessages from './productRoleMessages';
import baseStyles from '../../styles/app.scss';

class RoleView extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
  };
  render() {
    const modelQueryAttributes = [
      'id',
      'name',
      {
        products: ['id'],
        parentColumn: 'roleId',
        joinTable: 'productRole',
        joinAttributes: ['id'],
        isSelect: true,
      },
    ];

    const viewAttributes = {
      name: { type: 'text', required: true },
      productRole: {
        type: 'model',
        viewAttributes: {
          product: {
            type: 'selectModel',
            query: 'products',
            columnName: 'productId',
            viewAttribute: 'name',
            required: true,
          },
        },
      },
    };
    const messages = {
      messageList: RoleMessages,
      productRole: { messageList: productRoleMessages },
    };
    return (
      <CrudView
        headerName="Role"
        modelName="role"
        modelQueryAttributes={modelQueryAttributes}
        messages={messages}
        viewAttributes={viewAttributes}
        match={this.props.match}
      />
    );
  }
}

export default withStyles(baseStyles)(RoleView);
